(ns practitest.frontend.search.views
  (:require
   [practitest.frontend.common.dom :as dom]
   [practitest.frontend.common.mixpanel :as mixpanel]
   [reagent.core            :as reagent]
   [re-frame.core           :as re-frame]
   [clojure.string          :as string]
   [cljs.pprint             :refer [pprint]]
   [practitest.frontend.common-old-fe.logging :as log]
   [practitest.frontend.search.subs    :refer [map-user-name map-entity-name]]
   [practitest.frontend.common-old-fe.i18n          :as i18n]
   [practitest.frontend.common.i18n :refer [get-translation]]
   [practitest.frontend.common.dom :as common-dom]
   [practitest.frontend.components.overlay2 :as overlay2]
   [practitest.frontend.components.tooltip :as tooltip]
   [practitest.frontend.components2.search-box :as search-box]
   [practitest.frontend.common.permissions :as permissions]
   [practitest.frontend.components.icons :as icons]))

(def charts (atom {}))

(defn ajax-loader []
  (let [show (re-frame/subscribe [:search/is-searching])]
    (fn []
      (when @show [:div.loader
                    ;; TODO: switch to new spinner component
                    [:i {:class "fa fa-spinner fa-spin fa-5x"}]]))))

(defn collapse-expand-all [facets]
  [:div.collapse-expand-all.mb-2
   [:a {:class "pointer_link"
        :on-click (fn [_]
                    (re-frame/dispatch [:search/set-expand true])
                    (js/mixpanel.track "Advanced search - refiner"))}
    (i18n/t :expand_all)]
   [:span " | "]
   [:a {:class "pointer_link"
        :on-click #(re-frame/dispatch [:search/set-expand false])}
    (i18n/t :collapse_all)]])

(def shit
  {"PASSED"        "var(--pt-color-success)"
   "NOT COMPLETED" "var(--pt-color-status-not-completed)"
   "BLOCKED"       "var(--pt-color-warning)"
   "FAILED"        "var(--pt-color-error)"
   "NO RUN"        "var(--pt-color-status-no-run)"
   "N/A"           "var(--pt-color-status-na)"
   "NOT COVERED"   "var(--NOT-COVERED)"
   "STARTED"       "var(--pt-color-status-not-completed)"
   "RUNNING"       "var(--pt-color-status-running)"
   "Setup"         "LightGray"
   "Note"          "Khaki"
   "Bug"           "indianRed"
   "Question"      "LightGreen"
   "Test"          "LightSteelBlue"
   "Concern"       "GoldenRod"})

(defn results-total []
  [:h5.results_total
   [:span @(re-frame/subscribe [:search/results-total])]
   (i18n/t :results)])

(defn valid-query-length? []
  (let [query @(re-frame/subscribe [:search/query])
        min-str-len search-box/min-search-string-length]
    (>= (count query) min-str-len)))

(defn handle-search []
  (when (valid-query-length?)
    (re-frame/dispatch [:search/reset-page])
    (re-frame/dispatch [:search/search true])))

(defn results-query []
  (let [didyoumean @(re-frame/subscribe [:search/didyoumean])
        query @(re-frame/subscribe [:search/query])]
    (if didyoumean
      [:h3.advanced_search_header
       (i18n/t :no_results_for)
       query
       (i18n/t :did_you_mean)
       [:a {:href (str "/search?utf8=✓&query=" didyoumean)} didyoumean]]

      [:div.advanced_search_header
       [:h4.advanced_search_header
        (i18n/t :advanced_search)]
       [:div.search-input-warper
        [:input.search-input.mux-input.height
         {:auto-complete "off"
          :type          "text"
          :value         query
          :on-change     (fn [e]
                           (mixpanel/track "Search" {"Action" "Input Text Change Search Page"})
                           (re-frame/dispatch [:search/update-query (dom/event-value e)]))
          :on-key-down   #(when (= (.-key %) "Enter")
                            (handle-search))}]
        [:span.search-icon.search-search-icon
         {:on-click #(handle-search)}
         [icons/mux-search-with-bg]]]])))

(defn filter-results-header []
  (let [filter (re-frame/subscribe [:search/filters])
        users (re-frame/subscribe [:search/users-map])]
    (fn []
      (when (not-empty @filter)
        [:div.row
         [:div.col-12.headers_extra_padding
          [:div.inline-headers
           (doall
             (for [[i [facet-id {:keys [display_name is_user value]}]] (map-indexed vector @filter)
                   :let [label (cond
                                 is_user                       (map-user-name @users value (name facet-id))
                                 (= "___type" (name facet-id)) (map-entity-name value)
                                 :else                         value)]]
               ^{:key i} [:h6
                          [:span.badge.bg-primary.labelMargin display_name ": "
                           label
                           [:a {:href     "#"
                                :on-click (fn [e]
                                            (.preventDefault e)
                                            (re-frame/dispatch [:search/clear-filter facet-id])
                                            nil)}
                            [:i.fa.fa-times.fa-inverse.ms-2]]]]))]]]))))

(defn search-tips []
  (let [expanded? (reagent/atom false)]
    (fn []
      [:div.card.mb-3.expandable_tips_box.tips-box-color
       {:class    (when @expanded? "tips_open")
        :on-click #(swap! expanded? not)}
       [:div.card-header.tips-box-color.bold
        [:span.badge.bg-info.text-light "Info"] " " (i18n/t :search_tips)]
       (if @expanded?
         [:div.card-body
          [:p (i18n/t :use_special_characters)]
          [:span [:strong "\""] " " (i18n/t :search_exact_phrase)]
          [:br]
          [:span [:strong "*"] " " (i18n/t :match_characters)]
          [:br]
          [:span [:strong "?"] " " (i18n/t :match_one_char)]
          [:br]
          [:span [:strong "+"] " " (i18n/t :require_word_in_results)]
          [:br]
          [:span [:strong "-"] " " (i18n/t :exclude_records)]]
         [:div.card-body
          [:p (i18n/t :special_chars)]
          [:a.pointer_link (i18n/t :click_to_learn_more)]])])))

(defn results-header []
  [:div
   [:div.col-md-12.paddZero.row
    [:div.col-md-6
     [results-query]
     [filter-results-header]]
    [:div.col-md-6
     [search-tips]]]])

(def ^:private view-permission-by-entity-type
  {:qtest_design "tests_runs_view"
   :suite        "tests_runs_view"
   :et           "tests_runs_view"
   :issue        "issues_view"
   :requirement  "requirements_view"})

(defn entity-title-cell
  "Renders the entity title as a link only when the current user has at least
   view permission for the entity type. Otherwise renders plain, non-clickable
   text with a tooltip explaining why it cannot be opened."
  [entity-type url label]
  (let [permission (get view-permission-by-entity-type entity-type)]
    (if (or (nil? permission)
            (permissions/has-permission? permission))
      [:a {:href url} label]
      [tooltip/mux-tooltip
       {:position "top"
        :strategy :fixed
        :delay    {:show 200 :hide 200}}
       [:span (get-translation "search.no-view-permission"
                               "You don't have permission to view this item")]
       (fn [props]
         [:span.search-no-permission props label])])))

(defmulti result-row first)

(defmethod result-row :qtest_design [[_ entity url matches]]
  [:tr
   [:td.tdCapitalize (i18n/t :test)]
   [:td (:display_id entity)]
   [:td [entity-title-cell :qtest_design url (:name entity)]]
   [:td.tdToUpper (:run_status entity)]
   [:td (map-user-name @(re-frame/subscribe [:search/users-map])
                       (if (and (:assigned_to_type entity) (:assigned_to_id entity))
                         (str (:assigned_to_type entity) (str "-") (:assigned_to_id entity)) nil)
                       "assigned_to_id")]
   [:td (.format (js/moment (:updated_at entity)) "DD-MMM-YYYY")]
   [:td (search-box/format-search-found-in matches)]])

(defmethod result-row :suite [[_ entity url matches]]
  [:tr
   [:td.tdCapitalize (i18n/t :testset)]
   [:td (:display_id entity)]
   [:td [entity-title-cell :suite url (:name entity)]]
   [:td.tdToUpper (or (:run_status entity) (:status entity))]
   [:td (map-user-name @(re-frame/subscribe [:search/users-map])
                       (if (and (:assigned_to_type entity) (:assigned_to_id entity))
                         (str (:assigned_to_type entity) (str "-") (:assigned_to_id entity)) nil)
                       "assigned_to_id")]
   [:td (.format (js/moment (:updated_at entity)) "DD-MMM-YYYY")]
   [:td (search-box/format-search-found-in matches)]])


(defmethod result-row :et [[_ entity url matches]]
  [:tr
   [:td "ET"]
   [:td (:id entity)]
   [:td [entity-title-cell :et url (:title entity)]]
   [:td.tdToUpper (get-in entity [:instance :run_status])]
   [:td (map-user-name @(re-frame/subscribe [:search/users-map])
                       (if (and (get-in entity [:instance :assigned_to_type]) (get-in entity [:instance :assigned_to_id]))
                         (str (get-in entity [:instance :assigned_to_type]) (str "-") (get-in entity [:instance :assigned_to_id])) nil)
                       "assigned_to_id")]
   [:td (.format (js/moment (:updated_at entity)) "DD-MMM-YYYY")]
   [:td (search-box/format-search-found-in matches)]])


(defmethod result-row :default [[entity-type entity url matches]]
  [:tr
   [:td.tdCapitalize entity-type]
   [:td (:display_id entity)]
   [:td [entity-title-cell entity-type url (or (:name entity) (:title entity))]]
   [:td.tdToUpper (or (:status entity) (:status_name entity) (:run_status entity))]
   [:td (map-user-name @(re-frame/subscribe [:search/users-map])
                       (if (and (:assigned_to_type entity) (:assigned_to_id entity))
                         (str (:assigned_to_type entity) (str "-") (:assigned_to_id entity)) nil)
                       "assigned_to_id")]
   [:td (.format (js/moment (:updated_at entity)) "DD-MMM-YYYY")]
   [:td (search-box/format-search-found-in matches)]])

(defn results-table []
  (let [entities (re-frame/subscribe [:search/results-table])]
    (fn []
      [:table.table.table-striped.table-bordered.results-table
       {:cell-spacing "0" :width "100%"}
       [:thead
        [:tr
         [:th (i18n/t :type)]
         [:th "Id"]
         [:th (i18n/t :title_name)]
         [:th (i18n/t :status)]
         [:th (i18n/t :assigned_to)]
         [:th (i18n/t :updated)]
         [:th (i18n/t :found_in)]]]
       [:tbody
        (for [[i r] (map-indexed vector @entities)]
          ^{:key i} [result-row [(ffirst (:entity r)) (:entity2 r) (:url r) (set (keys (:matches r)))]])]])))

(defn facet-values-list [facet]
  (let [selected-values @(re-frame/subscribe [:search/selected-facet-values (:facet_id facet)])]
    [:div.row.facet_row_padder
     [:a {:href     "#"
          :on-click #(.preventDefault %)}
      [:div.card.search-card.facet
       [:div.card-body.search-facets
        {:on-click (fn [_]
                     (mixpanel/track "Search" {"Action" "Facets in Search Page"})
                     (re-frame/dispatch [:search/set-chart-facet-active facet])
                     (js/mixpanel.track "Advanced search - refiner"))}
        (:field_display_name facet) (if (:active facet)
                                      [:i.fa.fa-chevron-up.fa-fw.pull-right]
                                      [:i.fa.fa-chevron-down.fa-fw.pull-right])]]]
     (when (:active facet)
       [:div.col-xs-12.col-sm-12.col-md-6
        [:ul.facet_list.panel-collapse.ulMarger {:id (:facet_id facet)}
         (doall
           (for [[i [v dv c]] (map-indexed vector (sort-by last > (:values facet)))]
             ^{:key i}
             [:li.pointer_link
              [:label
               ; not deleted since will be needed soon for the multiselect
               ; [:input {:type "checkbox"
               ;         :checked (contains? selected-values v)
               ;         :on-change #(do
               ;                       (re-frame/dispatch [:search/toggle-facet-value (:facet_id facet) v])
               ;                       (re-frame/dispatch [:search/set-filter facet v]))}]
               [:span {:on-click #(do
                                    ;(re-frame/dispatch [:search/toggle-facet-value (:facet_id facet) v])
                                    (re-frame/dispatch [:search/set-filter facet v]))}
                [:a.text-nowrap
                 {:on-click      #(do
                                    ;(re-frame/dispatch [:search/toggle-facet-value (:facet_id facet) v])
                                    (re-frame/dispatch [:search/set-filter facet v]))}
                 [:span.facet-value {:title dv} dv]
                 " " [:span.badge.search-badge c]]]]]))]])]))

(defn facet-list []
  (let [facets (re-frame/subscribe [:search/facet-list])]
    (reset! charts {})
    (fn []
      [:div.facet-list
       [collapse-expand-all facets]
       (for [[i r] (map-indexed vector @facets)]
         ^{:key i} [facet-values-list r])])))

(defn left-side-bar []
  [:div.leftNav
   [facet-list]])

(defn pagination []
  (let [pages        (re-frame/subscribe [:search/pages])
        current-page (re-frame/subscribe [:search/current-page])
        total-pages  (re-frame/subscribe [:search/total-pages])]
    (fn [db]
      [:ul.pagination.search-pagination
       [:li.page-item {:class (when (= (first @pages) @current-page) "disabled")}
        [:button.page-link {:on-click #(re-frame/dispatch [:search/set-page (- @current-page 1)])} (i18n/t :previous)]]
       (when (and (> @total-pages 10) (> (first @pages) 1))
         [:li.page-item {:class "disabled"} [:span.page-link [:i.fa.fa-ellipsis-h]]])
       (doall
         (for [i @pages]
           ^{:key i} [:li.page-item {:class (when (= i @current-page) "active")}
                      [:button.page-link {:on-click #(re-frame/dispatch [:search/set-page i])} i]]))
       (when (and (> @total-pages 10) (< (last @pages) @total-pages))
         [:li.page-item {:class "disabled"} [:span.page-link [:i.fa.fa-ellipsis-h]]])
       [:li.page-item {:class (when (= (last @pages) @current-page) "disabled")}
        [:button.page-link.search-next
         {:on-click #(re-frame/dispatch
                       [:search/set-page (+ 1 @current-page)])} (i18n/t :next)]]
       [:li.page-item.search-rows-in-page
        [:select.form-select
         {:on-change #(re-frame/dispatch [:search/set-table-size (-> % .-target .-value js/parseInt)])}
         [:option {:default-value "10" :value "10"} "10"]
         [:option {:value "20"} "20"]
         [:option {:value "50"} "50"]
         [:option {:value "100"} "100"]]]])))

(defn main-panel []
  [:div.old-frontend-container
   [:div.container-fluid.old-frontend-inner-container
    [results-header]
    [:div.row
     [:div.col-md-12.paddZero.d-flex
      [:div.col-xs-4.col-xl-3
       [left-side-bar]]
      [:div.search-right-side.col-xs-8.col-xl-9
       [:span.pagination-results-row
        [pagination]
        [results-total]]
       [ajax-loader]
       [results-table]]]]
    (when ^boolean goog.DEBUG
      [:div.row
       [:pre {:style {:height 200 :overflow-y :auto}}
        (with-out-str (pprint @re-frame.db/app-db))]])]])
